import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';

export class Documents extends AbstractComponent {
  init() {
    if (this.options.custom) {
      return;
    }

    this.options.filter = {
      document_types: 'all',
      year: 'all',
    };

    this.emptyMessageEl = this.el.querySelector('[data-documents-no-results]');
    this.items = this.el.querySelectorAll('[data-documents-item]');
    this.loadMoreWrapperEl = this.el.querySelector('[data-documents-load-more-wrapper]');
    this.loadMoreEl = this.el.querySelector('[data-documents-load-more]');
    this.filterSelects = this.el.querySelectorAll('[data-filter-select]');

    if (this.filterSelects.length === 0) {
      return;
    }

    this.initSelects();
    this.initLoadMore();
    this.filter(true);
  }

  initSelects() {
    this.filterSelects.forEach((el) => {
      const select = el.querySelector('select');

      el.addEventListener('change', (e) => {
        this.options.filter[el.dataset.filterSelect] = select.value;
        this.filter(true);
      });
    });
  }

  initLoadMore() {
    this.loadMoreEl.addEventListener('click', () => {
      this.options.page += 1;
      this.filter();
    });
  }

  filter(changed = false) {
    if (changed) {
      this.options.page = 1;
    }

    let displayOffset = (this.options.page - 1) * this.options.perPage;
    const eligible = [];

    this.items.forEach((item) => {
      const type = item.dataset.type.split('|');
      const year = item.dataset.year;

      const typeMatch = this.options.filter.document_types === 'all' || type.includes(this.options.filter.document_types);
      const yearMatch = this.options.filter.year === 'all' || this.options.filter.year === year;

      const match = typeMatch && yearMatch;

      if (!match) {
        this.hide(item);
      } else {
        eligible.push(item);
      }
    });

    eligible.forEach((item, index) => {
      if (index >= displayOffset && index < displayOffset + this.options.perPage) {
        item.classList.remove('is-hidden');
      } else if (changed) {
        this.hide(item);
      }
    });

    const visibleItems = Array.from(this.items).filter((item) => !item.classList.contains('is-hidden'));
    this.emptyMessageEl.classList.toggle('is-hidden', visibleItems.length !== 0);
    this.loadMoreWrapperEl.classList.toggle('is-hidden', eligible.length <= displayOffset + this.options.perPage);
  }

  hide(item) {
    item.classList.add('is-hidden');
  }

  // initSearch() {
  //   const input = this.el.querySelector('[data-documents-search-input]');
  //   const noResults = this.el.querySelector('[data-documents-no-results]');
  //   const items = this.el.querySelectorAll('[data-documents-item]');
  //
  //   input.addEventListener('input', (e) => {
  //     const value = e.target.value.toLowerCase();
  //     const hidden = [];
  //
  //     items.forEach((item) => {
  //       const name = item.dataset.file.toLowerCase();
  //
  //       if (name.includes(value)) {
  //         item.classList.remove('is-hidden');
  //       } else {
  //         item.classList.add('is-hidden');
  //         hidden.push(name)
  //       }
  //     });
  //
  //     noResults.classList.toggle('is-hidden', hidden.length !== items.length)
  //   });
  // }
}

register('documents', Documents);
